var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 56,
    viewBox: "0 0 63 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5355 54.1129L12.9688 41.3095V14.4049L37.5355 2L62 14.4049V41.3095L37.5355 54.1129Z",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 14.4049L37.4844 27.2083L12.8565 14.4049",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4851 27.545V54.1124",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.965 6.29248L52.8064 19.3718V24.4809L51.7645 24.6035L50.0075 26.5348L48.1484 26.9128L46.6775 28.2923V22.4373L22.4683 9.56231L28.965 6.29248Z",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3166 11.8939L17.1324 8.51428H12.2149L2 18.8481L10.0823 26.9709L20.3166 16.8027V11.8939Z",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9343 13.9978C15.6714 14.2607 15.2429 14.2607 14.98 13.9978C14.7171 13.7348 14.7171 13.3063 14.98 13.0433C15.2429 12.7803 15.6714 12.7803 15.9343 13.0433C16.1972 13.3063 16.1972 13.7348 15.9343 13.9978Z",
    fill: "white",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing);
export default __webpack_public_path__ + "static/media/pricing.0f397ff8.svg";
export { ForwardRef as ReactComponent };